<template>
  <div class="wrapper w-mb2">
    <table>
      <thead v-if="thead(block.data).length > 0">
        <tr v-for="(items, tr_index) in thead(block.data)" :key="tr_index">
          <th v-for="(item, th_index) in items" :key="th_index">
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody v-if="tbody(block.data).length > 0">
        <tr v-for="(items, tr_index) in tbody(block.data)" :key="tr_index">
          <td v-for="(item, td_index) in items" :key="td_index">
            {{ item }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "TableBlock",
  props: ["block"],
  methods: {
    thead(data) {
      return data.withHeadings ? data.content.slice(0, 1) : [];
    },
    tbody(data) {
      return data.withHeadings ? data.content.slice(1) : data.content;
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid rgb(222, 226, 230);

  tbody,
  td,
  tfoot,
  th,
  thead,
  tr {
    padding: 0.5rem 0.5rem;
    border-color: inherit;
    border-style: solid;
    border-width: 1px;
  }
}
</style>
